<template>
    <TemplateContentPage
        v-if="productionHouse"
        class="template--venue"
    >
        <template #hero>
            <HeroSecondary
                :title="productionHouse.name"
                :post-title="productionHouse.city?.name"
                :logo="productionHouse.logo"
                :description="productionHouse.description"
            >
                <template #cta>
                    <ProductionHouseFollowButton :production-house-id="productionHouse.id" />
                </template>
            </HeroSecondary>
        </template>
        

        <template #default>
            <template
                v-for="eventContentHighlight in productionHouse?.eventContentHighlights"
                :key="eventContentHighlight.id"
            >
                <BaseSection
                    data-width="content-sm"
                    color-theme="light"
                    class="center"
                    data-spacing="md"
                >
                    <SocialLinks :social-links="productionHouse" />
                </BaseSection>
                <EventHighlight
                    :event-content="eventContentHighlight"
                    color-theme="light"
                />

                <EventBundleSection
                    :event-bundle-query="{
                        __typename: '[custom]event_bundle_custom',
                        eventContent: [eventContentHighlight.id]
                    }"
                    color-theme="light"
                >
                    <template #title>
                        Plan je bezoek
                    </template>
                </EventBundleSection>
            </template>

            <QueryUpdates
                v-slot="{ entries }"
                :production-house="[productionHouse.id]"
            >
                <BaseSection
                    v-if="entries && entries.length > 0"
                    data-width="content-sm"
                    color-theme="light"
                >
                    <ArticleCard :entry="entries[0]" />
                </BaseSection>
            </QueryUpdates>

            <QueryEventContentBundle
                v-slot="{ result }"
                :production-house="productionHouse.id.toString(10)"
                :lazy="true"
            >
                <BaseSection
                    v-if="result && result.length > 0"
                    color-theme="light"
                    width="bleed"
                    data-spacing="lg"
                >
                    <template #title>
                        Plan je bezoek
                    </template>

                    <template #default>
                        <BaseSlider
                            :items="result"
                            class="event-slider"
                        >
                            <template #slide="{ item }">
                                <EventContentCard
                                    :event="item"
                                    drag-to-scroll="ignore"
                                    draggable="false"
                                />
                            </template>
                        </BaseSlider>
                    </template>
                </BaseSection>
            </QueryEventContentBundle>

            <ArtistSection
                color-theme="light"
                :production-house="relationFilterToString([productionHouse.id])"
            >
                <template #title>
                    Makers
                </template>
            </ArtistSection>

            <ProductionHouseSection
                :skip="relationFilterToString([productionHouse.id])"
                preset="has-events"
            >
                <template #title>
                    Check ook eens
                </template>
            </ProductionHouseSection>
            
            <EventCta :ctas="filterCtas(ctas, 'productionHouse')" />
        </template>
    </TemplateContentPage>
</template>

<script setup lang="ts">
const route = useRoute();

const ctas = useCta();

const { data } = await useAsyncFetchLaravel<{
    data: ProductionHouseDetailData
}>(`/v2.0/production-houses/${route.params.slug}`);

const productionHouse = computed(() => data.value?.data);

if (!productionHouse.value) {
    throw createError({ statusCode: 404, statusMessage: 'Page Not Found' });
}
</script>
